import { Spin, Typography } from "antd";
import { useEffect, useState } from "react";
import { FormProvider } from "react-hook-form";
import { useLocation, useParams } from "react-router-dom";

import { AdminMenuLayout } from "../../../shared/components";
import { useKits, useKitsById } from "../hooks";
import { KitsForm, KitsProductsPanel } from "./kitById";
import { WrapperCardKits, WrapperTabNavKits } from "./styled";

const { Paragraph } = Typography;

export const KitsById = () => {
  const { isUpdateKit, formMethodsCreate, formMethodsUpdate } = useKits();
  const { isValidate } = useKitsById();
  const location = useLocation();
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("1");
  const canManageProducts =
    isUpdateKit && id != null && id !== "new" && !Number.isNaN(Number(id));

  useEffect(() => {
    const tab = (location.state as { kitTab?: string } | null)?.kitTab;
    if (tab && canManageProducts) setActiveTab(tab);
  }, [location.state, location.pathname, canManageProducts]);

  useEffect(() => {
    if (!canManageProducts) setActiveTab("1");
  }, [canManageProducts]);

  return (
    <AdminMenuLayout pageDescription="KitsById" title="KitsById">
      <WrapperCardKits>
        {!isValidate ? (
          <Spin size="large" />
        ) : (
          <WrapperTabNavKits
            activeKey={activeTab}
            onChange={setActiveTab}
            items={[
              {
                label: `DATOS DEL KIT`,
                key: "1",
                children: (
                  <FormProvider
                    {...(isUpdateKit ? formMethodsUpdate : formMethodsCreate)}
                  >
                    <KitsForm />
                  </FormProvider>
                ),
              },
              {
                label: `PRODUCTOS DEL KIT`,
                key: "2",
                children: canManageProducts ? (
                  <KitsProductsPanel />
                ) : (
                  <div style={{ padding: 24 }}>
                    <Paragraph>
                      Guarda el kit en la pestaña <strong>Datos del kit</strong>{" "}
                      para poder asociar productos del catálogo.
                    </Paragraph>
                  </div>
                ),
              },
            ]}
          />
        )}
      </WrapperCardKits>
    </AdminMenuLayout>
  );
};
